// 관세사 — 관리 업체 리스트 (Wave 5.1, 2026-05-29)
//   백엔드: GET /clearance-broker/companies?month=, POST /clearance-broker/settlement/rate
//   업체별 이번달 면장 건수/수수료/미정산 + 수수료율(업체 override / 관세사 기본율) 인라인 수정.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
function won(n) { return (Number(n) || 0).toLocaleString('ko-KR'); }
function thisMonth() { return new Date().toISOString().slice(0, 7); }

function CustomsBrokerCompanies({ showToast, goSettlement }) {
  var st = showToast || function () {};
  var monthState = useState(thisMonth()); var month = monthState[0]; var setMonth = monthState[1];
  var dataState = useState(null); var data = dataState[0]; var setData = dataState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];
  var agencyRateState = useState(''); var agencyRateInput = agencyRateState[0]; var setAgencyRateInput = agencyRateState[1];

  function load() {
    setLoading(true);
    authFetch(API + '/clearance-broker/companies?month=' + encodeURIComponent(month))
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { setData(d); setAgencyRateInput(String(d.agencyRate || 0)); } setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [month]);

  function saveAgencyRate() {
    authFetch(API + '/clearance-broker/settlement/rate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ rate: Number(agencyRateInput) || 0 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('기본 수수료율 저장됨', ''); load(); } else st((d && d.error) || '저장 실패', 'err'); })
      .catch(function () { st('저장 실패', 'err'); });
  }
  function saveCompanyRate(c, raw) {
    var body = { companyId: c.id, rate: raw === '' ? null : (Number(raw) || 0) };
    authFetch(API + '/clearance-broker/settlement/rate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st(c.name + ' 수수료율 ' + (raw === '' ? '기본율로 초기화' : raw + '%'), ''); load(); } else st((d && d.error) || '저장 실패', 'err'); })
      .catch(function () { st('저장 실패', 'err'); });
  }

  // 미정산 리마인더 — 청구(확정)됐으나 미입금 업체 요약을 관세사 본인에게 push
  function sendReminder() {
    authFetch(API + '/clearance-broker/settlement/remind', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) st(d.count > 0 ? '미정산 ' + d.count + '개 업체 알림 전송됨 (₩' + (d.totalUnpaid || 0).toLocaleString('ko-KR') + ')' : '미정산 건이 없습니다', '');
        else st((d && d.error) || '알림 실패', 'err');
      }).catch(function () { st('알림 실패', 'err'); });
  }

  var companies = (data && data.companies) || [];
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <label style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>{'정산월'}</label>
          <input type="month" value={month} onChange={function (e) { setMonth(e.target.value); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13 }} />
          <button onClick={sendReminder} style={{ padding: '6px 12px', background: '#d97706', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'🔔 미정산 리마인더'}</button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: '6px 12px' }}>
          <span style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>{'기본 수수료율'}</span>
          <input type="number" step="0.1" min="0" value={agencyRateInput} onChange={function (e) { setAgencyRateInput(e.target.value); }} style={{ width: 64, padding: '4px 8px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, textAlign: 'right' }} />
          <span style={{ fontSize: 12, color: '#64748b' }}>{'%'}</span>
          <button onClick={saveAgencyRate} style={{ padding: '4px 12px', background: NAVY, color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'저장'}</button>
        </div>
      </div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && companies.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'🏢'}</div>
          <div style={{ marginTop: 8 }}>{'관리 업체가 없습니다 (관리자 매핑 필요)'}</div>
        </div>
      )}
      {!loading && companies.length > 0 && (
        <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={thS}>{'업체명'}</th>
                <th style={thS}>{'담당자'}</th>
                <th style={thS}>{'연락처'}</th>
                <th style={thCenter}>{'대기'}</th>
                <th style={thCenter}>{'완료'}</th>
                <th style={thRight}>{'이번달 수수료'}</th>
                <th style={thRight}>{'미정산'}</th>
                <th style={thCenter}>{'수수료율'}</th>
                <th style={thCenter}>{'정산'}</th>
              </tr>
            </thead>
            <tbody>
              {companies.map(function (c) {
                return (
                  <tr key={c.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{c.name}</td>
                    <td style={tdS}>{c.ceo || '-'}</td>
                    <td style={tdS}>{c.tel || '-'}</td>
                    <td style={tdCenter}>{c.waitCount > 0 ? <span style={{ color: '#ea580c', fontWeight: 700 }}>{c.waitCount}</span> : '-'}</td>
                    <td style={tdCenter}>{c.doneCount || 0}</td>
                    <td style={tdRight}>{won(c.monthFee)}</td>
                    <td style={Object.assign({ color: c.unpaid > 0 ? '#dc2626' : '#16a34a', fontWeight: 700 }, tdRight)}>{c.unpaid > 0 ? won(c.unpaid) : (c.settled ? '완납' : '0')}</td>
                    <td style={tdCenter}>
                      <input type="number" step="0.1" min="0" defaultValue={c.feeRate}
                        onBlur={function (e) { if (String(Number(e.target.value)) !== String(c.feeRate)) saveCompanyRate(c, e.target.value); }}
                        style={{ width: 56, padding: '3px 6px', borderRadius: 6, border: '1px solid ' + (c.feeRateOverridden ? '#fbbf24' : '#cbd5e1'), fontSize: 12, textAlign: 'right' }} />
                      <span style={{ fontSize: 10, color: c.feeRateOverridden ? '#d97706' : '#94a3b8', marginLeft: 4 }}>{c.feeRateOverridden ? '업체' : '기본'}</span>
                    </td>
                    <td style={tdCenter}>
                      <button onClick={function () { goSettlement(c.id); }} style={{ padding: '4px 12px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'정산서'}</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>{'수수료율 칸을 수정하면 해당 업체 율로 저장(빈칸 → 기본율). 수수료 = 면장 1건 인보이스 금액 × 율%.'}</div>
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thCenter = Object.assign({}, thS, { textAlign: 'center' });
var thRight = Object.assign({}, thS, { textAlign: 'right' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdCenter = Object.assign({}, tdS, { textAlign: 'center' });
var tdRight = Object.assign({}, tdS, { textAlign: 'right' });

export default CustomsBrokerCompanies;
